var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlogEarbuds = function SvgBlogEarbuds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 109,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blogEarbuds_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#blogEarbuds_svg__b)",
    d: "M28.51 3.84 15.98.62C7.38-.1 0 6.68 0 15.31v58.93c0 3.14 2.54 5.68 5.68 5.68s5.68-2.54 5.68-5.68c0 0 .33-52.57 0-52.68 9.47 10.8 19.87-.47 19.87-4.29V7.36c0-1.66-1.12-3.11-2.73-3.52z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7200CC",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "M31.15 4.49 18.62 1.27C10.02.55 2.64 7.34 2.64 15.97V74.9c0 3.14 2.54 5.68 5.68 5.68S14 78.04 14 74.9c0 0 .33-52.57 0-52.68 9.47 10.8 19.87-.47 19.87-4.29V8.02c0-1.66-1.12-3.11-2.73-3.52zM25.8 3.5v22.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "M29.14 13.77c.06-6.87-2.92-6.87-2.92-6.87v16.17s2.86-2.39 2.92-9.29z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7200CC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "M12.73 16.32h5.09M8.39 72.16h5.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#blogEarbuds_svg__c)",
    d: "m89.54 31.02 12.3 4c7.65 4 10.24 13.68 5.61 20.97l-31.59 49.74a5.68 5.68 0 0 1-7.84 1.75 5.68 5.68 0 0 1-1.75-7.84s27.9-44.55 28.24-44.47c-13.78 4.04-16.52-11.05-14.47-14.28l5.31-8.37c.89-1.4 2.62-2.02 4.19-1.51z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7200CC",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "m86.96 30.16 12.3 4c7.65 4 10.24 13.68 5.61 20.97l-31.59 49.74a5.68 5.68 0 0 1-7.84 1.75 5.68 5.68 0 0 1-1.75-7.84s27.9-44.55 28.24-44.47c-13.78 4.04-16.52-11.05-14.47-14.28l5.31-8.37c.89-1.4 2.62-2.02 4.19-1.51zM92.01 32.19 79.74 51.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "M83.68 39.07c3.63-5.83 6.15-4.24 6.15-4.24l-8.67 13.65s-1.13-3.55 2.52-9.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7200CC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "m96.17 50.02-4.3-2.73M69.9 99.48l-4.3-2.73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blogEarbuds_svg__b",
    x1: 0,
    x2: 31.24,
    y1: 40.24,
    y2: 40.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7200CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B69BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blogEarbuds_svg__c",
    x1: 94.091,
    x2: 67.72,
    y1: 77.041,
    y2: 60.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7200CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B69BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "blogEarbuds_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h109.76v108.73H0z"
  })))));
};
export { SvgBlogEarbuds as ReactComponent };
export default "/_next/static/media/src/components/Blog/assets/blogEarbuds.e49b06e0a088b229bd67e9d1c6feeef5.svg";